import { SupplierUploadViewModel } from '@ail/orders-api'
import { Dialog } from '../../common/Dialog/Dialog'
import './LogsModal.scss'

interface LogsModalProps {
  supplierUpload?: SupplierUploadViewModel
  onClose: () => void
}

export function LogsModal(props: LogsModalProps) {
  return (
    <Dialog
      open={!!props.supplierUpload}
      title={props.supplierUpload?.attachmentName}
      onClose={props.onClose}
      icon="icon-marker"
      width={550}
    >
      <div className="logs-modal">
        {props.supplierUpload?.logs.map((row, idx) => (
          <div key={idx} className="logs-modal-row">
            <i className={row.type === 'error' ? 'icon-warning' : 'icon-info'} />
            {row.message}
          </div>
        ))}
      </div>
    </Dialog>
  )
}
